import { render } from "./Demographics.vue?vue&type=template&id=141a176c"
import script from "./Demographics.vue?vue&type=script&lang=ts"
export * from "./Demographics.vue?vue&type=script&lang=ts"
script.render = render

export default script